












import {Vue} from 'vue-property-decorator';
import {LControl} from 'vue2-leaflet';

export default Vue.extend({
    components: {LControl},
    props: {
        types: {
            type: Array,
            validator: value => value.length !== 0,
        },
        enabled: {
            type: Boolean,
            default: true,
        },
    },
    watch: {
        selectedTypeIndex(index) {
            this.$emit('change', this.types[index]);
        },
    },
    data: () => ({
        selectedTypeIndex: 0,
    }),
});
